import { format, parseJSON } from "date-fns";

export class WeatherForecastController {
	data: Record<string, any>;
	lastUpdatedString: string;
	dateDayBeforeMonth: boolean;
	weatherIconDict: Record<string, string>;

	blockDomain: string;
	/* @ngInject */
	constructor(blockDomain: string) {
		this.blockDomain = blockDomain;
		
		this.weatherIconDict = {
			"moderate or heavy snow in area with thunder": "wsymbol_0012_heavy_snow_showers",
			"patchy light snow in area with thunder": "wsymbol_0016_thundery_showers",
			"moderate or heavy rain in area with thunder": "wsymbol_0024_thunderstorms",
			"patchy light rain in area with thunder": "wsymbol_0016_thundery_showers",
			"moderate or heavy showers of ice pellets": "wsymbol_0021_cloudy_with_sleet",
			"light showers of ice pellets": "wsymbol_0013_sleet_showers",
			"moderate or heavy snow showers": "wsymbol_0012_heavy_snow_showers",
			"light snow showers": "wsymbol_0011_light_snow_showers",
			"moderate or heavy sleet showers": "wsymbol_0013_sleet_showers",
			"light sleet showers": "wsymbol_0013_sleet_showers",
			"torrential rain shower": "wsymbol_0018_cloudy_with_heavy_rain",
			"moderate or heavy rain shower": "wsymbol_0010_heavy_rain_showers",
			"light rain shower": "wsymbol_0009_light_rain_showers",
			"ice pellets": "wsymbol_0021_cloudy_with_sleet",
			"heavy snow": "wsymbol_0020_cloudy_with_heavy_snow",
			"patchy heavy snow": "wsymbol_0012_heavy_snow_showers",
			"moderate snow": "wsymbol_0020_cloudy_with_heavy_snow",
			"patchy moderate snow": "wsymbol_0020_cloudy_with_heavy_snow",
			"light snow": "wsymbol_0011_light_snow_showers",
			"patchy light snow": "wsymbol_0011_light_snow_showers",
			"moderate or heavy sleet": "wsymbol_0019_cloudy_with_light_snow",
			"light sleet": "wsymbol_0021_cloudy_with_sleet",
			"moderate or heavy freezing rain": "wsymbol_0021_cloudy_with_sleet",
			"light freezing rain": "wsymbol_0021_cloudy_with_sleet",
			"heavy rain": "wsymbol_0018_cloudy_with_heavy_rain",
			"heavy rain at times": "wsymbol_0010_heavy_rain_showers",
			"moderate rain": "wsymbol_0018_cloudy_with_heavy_rain",
			"moderate rain at times": "wsymbol_0010_heavy_rain_showers",
			"light rain": "wsymbol_0017_cloudy_with_light_rain",
			"patchy light rain": "wsymbol_0017_cloudy_with_light_rain",
			"heavy freezing drizzle": "wsymbol_0021_cloudy_with_sleet",
			"freezing drizzle": "wsymbol_0021_cloudy_with_sleet",
			"light drizzle": "wsymbol_0017_cloudy_with_light_rain",
			"patchy light drizzle": "wsymbol_0009_light_rain_showers",
			"freezing fog": "wsymbol_0007_fog",
			"fog": "wsymbol_0007_fog",
			"blizzard": "wsymbol_0020_cloudy_with_heavy_snow",
			"blowing snow": "wsymbol_0019_cloudy_with_light_snow",
			"thundery outbreaks in nearby": "wsymbol_0016_thundery_showers",
			"patchy freezing drizzle nearby": "wsymbol_0021_cloudy_with_sleet",
			"patchy sleet nearby": "wsymbol_0021_cloudy_with_sleet",
			"patchy snow nearby": "wsymbol_0013_sleet_showers",
			"patchy rain nearby": "wsymbol_0009_light_rain_showers",
			"mist": "wsymbol_0006_mist",
			"overcast": "wsymbol_0004_black_low_cloud",
			"cloudy": "wsymbol_0003_white_cloud",
			"partly cloudy": "wsymbol_0002_sunny_intervals",
			"sunny": "wsymbol_0001_sunny",
			"clear": "wsymbol_0008_clear_sky_night",
		};
	}

	$onInit(): void {
		if (this.data && this.data.obs_time) {
			if (this.dateDayBeforeMonth) {
				this.lastUpdatedString = format(parseJSON(this.data.obs_time), "d MMM, h:mma");
			} else {
				this.lastUpdatedString = format(parseJSON(this.data.obs_time), "MMM d, h:mma");
			}
		} else {
			this.lastUpdatedString = "";
		}
	}

	getWeatherIcon(conditionDesc: string): string {
		let code: string;
		if (Object.keys(this.weatherIconDict).includes(conditionDesc.toLowerCase())) {
			code = this.weatherIconDict[conditionDesc.toLowerCase()];
		} else {
			code = "wsymbol_0999_unknown";
		}

		return `${this.blockDomain}/static/assets/weather-icons/${code}.svg`;
	}
}